import CreditCardForm from 'components/HappeningNonContent/ServiceBooking/ReviewAndPay/PaymentInfo/CreditCardForm/CreditCardForm';

export default CreditCardForm;
